import {context} from "../constants/context";
import {halClient} from "../hal";
import {BBService} from "../bb_service";

const sso = {
    memberLogin(options) {
        return new Promise((resolve, reject) => {
            if (!options.root) {
                options.root = '';
            }
            const url = options.root + `/api/${context.apiVersion}/login/sso/` + options.company_id;
            const data = {token: options.member_sso};
            halClient.$post(url, {}, data).then((login) => {
                    return login.$get('member').then((member) => {
                            member = BBService.login.setLogin(member);
                            return resolve(member);
                        }
                    );
                }
                , (err) => {
                    return reject(err);
                }
            );
        });
    },

    adminLogin(options) {
        return new Promise((resolve, reject) => {
            if (!options.root) {
                options.root = '';
            }
            const url = options.root + `/api/${context.apiVersion}/login/admin_sso/` + options.company_id;
            const data = {token: options.admin_sso};
            halClient.$post(url, {}, data).then((login) => {
                    return login.$get('administrator').then((admin) => {
                            return resolve(admin);
                        }
                    );
                }
                , (err) => {
                    return reject(err);
                }
            );
        });
    }
};

export {
    sso
}

